require('./linesTable.less');
import {LoDashStatic} from "lodash";
const _ = <LoDashStatic> require('lodash');

class LinesTableController {
    query ={
        limit: 100,
        page: 1,
        order: ''
    };
    tableDefinition;
    tableContent;
    columns;
    settings;
    initiated ;
    locationChangeListener;
    activeState;
    
    constructor(private OrderLines, private toastService, private $scope, private $state, private $location, private $filter){
        $scope.query = this.query;
        this.locationChangeListener = $scope.$on('$locationChangeSuccess', ()=>{this.setPaginationSettings()});
    }

    $onInit(){
        this.activeState = angular.copy(this.$state.current.name);
        this.columns = this.tableDefinition.columns;
        this.settings = this.tableDefinition.settings;
        this.setPaginationSettings();

        this.$scope.$watchCollection('query' , (newValue)=>{
            if(this.initiated && this.tableContent && this.activeState === this.$state.current.name){
                this.settings.onPaginate(newValue);
            }
            this.initiated = true;
        })
    }

    setPaginationSettings(){
        const queryParams = this.$location.search();
        this.query.limit = queryParams.pageSize ? parseInt(queryParams.pageSize) : 20;
        this.query.page = queryParams.pageNo ? parseInt(queryParams.pageNo) +1 : 1;
    }

    orderForward(line){
        if(line.orderNo){
            this.locationChangeListener();
            this.$state.go('loggedin.orders_orderdetails', {orderNo: line.orderNo});
        }
    }

    articleForward(line){
        if(line.articleNo){
            this.locationChangeListener();
            this.$state.go('loggedin.articles_articleprofile', {articleNo: line.articleNo});
        }
    }

    confirmDate(line) {
        var parsedDate = this.$filter('date')(line.deliveryDate, 'yyyy-MM-dd');
        this.OrderLines.setConfirmationDate({lineId:line.uniqueId, confirmationDate:parsedDate},{}).$promise.then(
            (success)=>{
                line.altered = false;
                this.toastService.showSimpleToast("Bekreftet dato har blitt satt!", 3000);
            },
            (error)=>this.toastService.parseError(error)
        );
    }

    isHighlighted (line){
        return (date)=>{
            if(line.routeDays === 0){
                return true;
            }
            var dayString = (date.getDay() || 7).toString(); // Sets sundays to 7 ( === 0)
            return line.routeDaysString.includes(dayString);
        };
    };

}

class TableOptions implements ng.IComponentOptions {
    bindings: any = {
        tableContent:'=',
        tableDefinition:'='
    };
    controller: string = 'rkcLinesTableController';
    controllerAs:string = 'c';
    template: any = require('./linesTable.html');
}

rkcApp.controller("rkcLinesTableController", ['OrderLines','toastService','$scope','$state','$location','$filter',function(OrderLines, toastService, $scope, $state, $location, $filter){
    return new LinesTableController(OrderLines, toastService, $scope, $state, $location, $filter);
}])
    .component("rkcLinesTable", new TableOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/lines/linesTable/linesTable.ts
 **/